@if (show()) {
  <aside
    class="compare-bar"
    role="region"
    aria-label="Productos a comparar"
  >
    <div class="compare-bar__inner">
      <ul class="compare-bar__slots" aria-label="Selección actual">
        @for (slot of slots(); track $index) {
          <li class="compare-bar__slot" [class.compare-bar__slot--empty]="!slot">
            @if (slot) {
              <img
                class="compare-bar__thumb"
                [src]="slot.imageUrl"
                [alt]="slot.name"
                loading="lazy"
              />
              <button
                type="button"
                class="compare-bar__slot-remove"
                [attr.aria-label]="'Quitar ' + slot.name + ' del comparador'"
                (click)="onRemove(slot.id)"
              >
                <app-icon [icon]="closeIcon" [size]="12" color="currentColor" />
              </button>
            } @else {
              <span class="compare-bar__slot-placeholder" aria-hidden="true"></span>
            }
          </li>
        }
      </ul>

      <div class="compare-bar__meta">
        <span class="compare-bar__count">
          <strong>{{ count() }}</strong
          ><span class="compare-bar__count-sep">/</span>{{ maxItems }}
        </span>
        <span class="compare-bar__label">en el comparador</span>
      </div>

      <div class="compare-bar__actions">
        <button
          type="button"
          class="compare-bar__clear"
          aria-label="Vaciar comparador"
          (click)="onClear()"
        >
          <app-icon [icon]="clearIcon" [size]="16" color="currentColor" />
          <span class="compare-bar__clear-label">Limpiar</span>
        </button>

        <app-button
          variant="primary"
          size="md"
          [disabled]="!canCompare()"
          (click)="onCompare()"
        >
          <div class="compare-bar__cta-content">
            <app-icon [icon]="compareIcon" [size]="16" color="currentColor" />
            <span>Comparar</span>
          </div>
        </app-button>
      </div>
    </div>
  </aside>
}
